import { useLocation } from 'react-router-dom';

export interface RouteParamsReturn {
	surgeonNpi: string;
	blockUnit: string;
	blockDate: string;
	recommendationId: string;
	pathname: string;
	hasAllParams: boolean;
}

export const useRouteParams = (): RouteParamsReturn => {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);

	const surgeonNpi = queryParams.get('surgeon') || 'ALL';
	const surgeonUnit = queryParams.get('unit') || '';
	const blockDate = queryParams.get('date') || '';
	const recommendationId = location.pathname.split('recommendation/')[1] || '';
	const hasAllParams = surgeonNpi !== 'ALL' && surgeonUnit && blockDate;

	return {
		surgeonNpi,
		blockUnit: surgeonUnit,
		blockDate,
		recommendationId,
		pathname: location.pathname,
		hasAllParams: !!hasAllParams
	};
};
